import { useEffect } from 'react';
import useEditEvent from '@app/data/editEvent/useEditEvent.tsx'
import { useValidation } from '@pages/makeEvent/hooks/useValidation.ts'
import SchemaForFormik from '@pages/eventEditing/components/tabsComponent/schema.ts'
import transformFieldsNames from '@pages/eventEditing/utils/transformFieldsName.ts'
import { toast } from 'react-toastify';


const useUpdateEventRequest = () => {
  const { build: editEvent, isLoading, isSuccess } = useEditEvent()

  const editHandler = (formikValues) => {
    const { status } = useValidation(SchemaForFormik, formikValues)
    if (status === 'failed') {
      toast('Что-то не так, проверьте все поля на всех вкладках', { type: 'error' })
      return
    }
    const preparedBody = transformFieldsNames(formikValues)
    editEvent(preparedBody)
  }

  useEffect(() => {
    if (isSuccess) {
      toast('Отправили на проверку!', { type: 'success' })
    }
  }, [isLoading])

  return { editHandler, isLoading }

}

export default useUpdateEventRequest